import { useQuery } from "@tanstack/react-query";
import { getPropertyTaxData } from "../../Requests";
import { useAppSelector } from "..";

function usePropertyTaxQuery(municipalKey: string, ownerId: string) {
  const access_token = useAppSelector(state => state.auth.user?.access_token) ?? '';
  return useQuery({
    queryKey: ["propertytax", municipalKey],
    queryFn: () => getPropertyTaxData(municipalKey, access_token, ownerId),
    enabled: !!access_token,
  });
}

export { usePropertyTaxQuery };
